import {isDefined} from '../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {nativeSidePanelFrames} from '../../../store/stateless/sidePanelFrameSelectors';

/*
 * Constants.
 */

export const sidePanelSwitcherWidth = 64; // px.
export const maxSidePanelToP3Ratio = 0.75;
export const maxSidePanelWidth = 600; // px.
// The minimum width of the side panel when a native plugin is shown.
export const minNativeSidePanelWidth = 322; // px.

/*
 * Helpers.
 */

export const computeIsNativeFrameId = (frameId: string) =>
  isDefined(nativeSidePanelFrames.find((frame) => frame.frameId === frameId));
